module.exports = __webpack_public_path__ + "resources/icon_50_close_small.9db84d70d91f55d1.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_50_close_small.png
// module id = 441
// module chunks = 0 1 2 3 4